module.exports = __webpack_public_path__ + "img/safety-glasses.a7e28b2b.svg";